import { ToolProviderIdEnum } from '../../../types';
/**
 * Unconditionally endpoint-routed tool providers (per-subscriber ChannelEndpoint only).
 * Tool webhook is mode-dependent — see {@link isEndpointRoutedToolProvider}.
 */
export const ENDPOINT_ROUTED_TOOL_PROVIDERS = new Set([
    ToolProviderIdEnum.PagerDuty,
    ToolProviderIdEnum.Opsgenie,
]);
/** True when tool-webhook credentials opt into per-subscriber endpoint routing. */
export function isToolWebhookDynamicRouting(credentials) {
    return credentials?.routingMode === 'dynamic';
}
/**
 * Whether a tool provider must route via subscriber ChannelEndpoints for this integration.
 * PagerDuty/Opsgenie always; tool-webhook only when `routingMode === 'dynamic'`.
 */
export function isEndpointRoutedToolProvider(providerId, credentials) {
    if (ENDPOINT_ROUTED_TOOL_PROVIDERS.has(providerId)) {
        return true;
    }
    if (providerId === ToolProviderIdEnum.Webhook) {
        return isToolWebhookDynamicRouting(credentials);
    }
    return false;
}
//# sourceMappingURL=tool-routing.js.map